module.exports = __webpack_public_path__ + "img/PDF.f49d2338.svg";